"use client"

import { useEffect } from "react";
import { Crisp } from "crisp-sdk-web";

const CrispChat = () => {
  useEffect(() => {
    Crisp.configure("496c4e99-9db3-4583-98e9-837b116629df");
  });

  return null;
}

export default CrispChat;